import type { ReactNode } from "react";

import type { View } from "@/features/views";
import { useActiveView } from "@/features/views/hooks/useActiveView";

type Props = {
    views: View[];
    children: ReactNode;
    fallback?: ReactNode;
};

/**
 * Renders `children` only when the user's effective active view is one of `views`.
 *
 * For minor per-view differences within an otherwise shared page. For swapping whole page
 * components by view, use `ViewPage` instead.
 */
const ViewBoundary = (props: Props) => {
    const { views, children, fallback = null } = props;

    const activeView = useActiveView();
    const isMatch = activeView !== null && views.includes(activeView);

    if (!isMatch) {
        return fallback;
    }

    return children;
};

export { ViewBoundary };
